export const YIMBA_SET_USER_DATA = 'YIMBA_SET_USER_DATA';
